import { render, staticRenderFns } from "./ValuerProfile.vue?vue&type=template&id=8be66dca&scoped=true&"
import script from "./ValuerProfile.vue?vue&type=script&lang=ts&"
export * from "./ValuerProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ValuerProfile.vue?vue&type=style&index=0&id=8be66dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be66dca",
  null
  
)

export default component.exports